import React from 'react';
import { Helmet } from 'react-helmet-async';
import { useTranslation } from 'react-i18next';
import { languages } from '@client/shared/utils/languageUtils/languageUtils';

function AllerDefaultHelmet() {
  const { t, i18n } = useTranslation(['metadata']);
  const currentLanguage = i18n.language;
  const currentUrl =
    typeof window === 'object'
      ? window.location.href
      : 'https://www.allersparks.com';
  const alternateUrls = Object.keys(languages).map((language) => {
    return {
      language: language,
      url: currentUrl.replace(currentLanguage, language),
    };
  });
  const title = t('metadata:home.title');
  const description = t('metadata:home.description');
  const metaData = [
    {
      name: 'description',
      content: description,
    },
    {
      property: 'og:title',
      content: title,
    },
    {
      property: 'og:description',
      content: description,
    },
    {
      property: 'og:image',
      content:
        'https://storage.googleapis.com/aller-assets-prod/assets/aller-social.jpg',
    },
    {
      property: 'og:type',
      content: 'website',
    },
    {
      name: 'keywords',
      content:
        'Influencer, karriär, nätverk, Aller media, ambassadör, varumärken, micro, microinfluencers, Icon, Icons, influencernätverk, influencerkarriär, sponsrade samarbeten, annonssamarbete, ELLE, ELLE Decoration, ELLE Mat & Vin, femina, MåBra, Baaam, Instagram, Influencer marketing, community, sociala medier',
    },
    {
      property: 'fb:app_id',
      content: '1532476386894933',
    },
    {
      name: 'twitter:card',
      content: 'summary_large_image',
    },
    {
      name: 'theme-color',
      content: '#1d1d1d',
    },
    {
      property: 'og:url',
      content: currentUrl,
    },
  ];

  return (
    <Helmet meta={metaData} defaultTitle={title}>
      <html lang={currentLanguage} />
      <title>{title}</title>
      {alternateUrls.map((alternateUrl, index) => {
        return (
          <link
            key={index}
            rel="alternate"
            hrefLang={alternateUrl.language}
            href={alternateUrl.url}
          />
        );
      })}
    </Helmet>
  );
}

AllerDefaultHelmet.propTypes = {};

export default React.memo(AllerDefaultHelmet);
